if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', 
    class HeroCarousel extends HTMLElement {
      constructor() {
        super();
        this.ELM_swiperWrapper = this.querySelector('.swiper-wrapper');
        this.ELM_currentItem = this.querySelector('.swiper-current-item');
        this.ELM_buttonNext = this.querySelector('.swiper-button-next.swiper-button--blank');
        this.ELM_buttonPrev = this.querySelector('.swiper-button-prev.swiper-button--blank');
        this.ELM_buttonNextSmall = this.querySelector('.swiper-button-next.swiper-button--small');
        this.ELM_buttonPrevSmall = this.querySelector('.swiper-button-prev.swiper-button--small');
        this.carouselOptions = {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 20,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'progressbar'
          },
          navigation: {
            nextEl: this.ELM_buttonNext,
            prevEl: this.ELM_buttonPrev,
          },
        }
        if (this.dataset.autoplay) {
          this.carouselOptions.autoplay = {
            delay: Number(this.dataset.autoplay) * 1000,
            disableOnInteraction: false
          }
        }
        if (this.dataset.loop) {
          this.carouselOptions.loop = true;
        }

        this.heroSwiper = new Swiper(this, this.carouselOptions);
        this.heroSwiper.on('slideChange', ({ realIndex }) => {
          this.ELM_currentItem.innerHTML = realIndex + 1;
        })
        this.ELM_buttonNextSmall.addEventListener('click', () => {
          this.ELM_buttonNext.dispatchEvent(new Event('click'));
        })
        this.ELM_buttonPrevSmall.addEventListener('click', () => {
          this.ELM_buttonPrev.dispatchEvent(new Event('click'));
        })

        this.ELM_swiperWrapper?.addEventListener('mouseover', e => {
          this.heroSwiper.autoplay.pause();
        })
        this.ELM_swiperWrapper?.addEventListener('mouseout', e => {
          this.heroSwiper.autoplay.resume();
        })
      }
    }
  )
}